module.exports = __webpack_public_path__ + "static/turbina_hidraulica-8646ece97bf2fe155ef677b486b4bfc5.png";